module.exports = __webpack_public_path__ + "static/media/procedure-mobile_cn.f527ceb2.jpg";